import React, { useEffect, useState, useRef } from "react";
import cn from 'classnames';
// import "../../mixins.scss";
import "./header.scss";
import Menu from "../../components/menu"

function Header(props) {
  const { components, page, setCurrentDate } = props;
  const [menuActive, setMenuActive] = useState(false);

//   useEffect(() => {console.log("111");},[menuActive])


  return <>

	<div className={cn("header", components === "fs" && "header--fs", components === "tm" && "header--tm", components === "three" && "header--three")}>
		<div className="header__wrap-text">
		<p className="header__text">
		{components == "fs" && <>
		2007 - <span>По настоящее время...</span> 
		</>}
		{components == "tm" && <>
		2007 - 2011{" "}{" "}|{" "}{" "}Начало истории
		</>}
		{components == "two" && <>
		2012 - 2016  |  Большой прорыв
		</>}
		{components == "three" && <>
		2017 - 2022  |  Авито сегодня
		</>}

			{/* 2007 - <span> По настоящее время...</span> */}
		</p>
		{components == "two" &&  <>
			<p className="header__text">
			<span> Когда показатели взлетают, работать приходится ещё больше</span>
		</p>
		</>}


		</div>

		<div className="logo header__logo">
			<a href="/" className="logo__link">
				<img src="/img/logo-black.svg" alt="logo" className="img"/>
			</a>
		</div>
		<button className="header__menu-btn" onClick={()=>setMenuActive(true)}>Меню</button>
		<Menu menuActive={menuActive} setCurrentDate={setCurrentDate} setMenuActive={setMenuActive}/>
	</div>
  </>;
}

export default Header;
